import * as React from 'react';
import ConfigLoader from './components/misc/config-loader';
import SinglePageApp from './SinglePageApp';
import '../../../ui-components/library/styles/scss_apps/_global.scss';
import './global.scss';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';
import { spConfig } from '@enginuity-common/types/window-config';

let configuredAppInsights = false;

const configureAppInsights = (config: spConfig) => {
  if (configuredAppInsights) {
    return;
  }

  var appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: config.aiInstrumentationKey,
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: { history: browserHistory }
      }
    }
  });

  appInsights.loadAppInsights();
  configuredAppInsights = true;
};

const browserHistory = createBrowserHistory({ basename: '' });
var reactPlugin = new ReactPlugin();


// To instrument various React components usage tracking, apply the `withAITracking` higher-order
// component function.
const InstrumentedSinglePageApp = withAITracking(reactPlugin, SinglePageApp, 'Account');

export const App = () => (
  <ConfigLoader ready={(config: spConfig) => {
    configureAppInsights(config);
    
    return (
      <InstrumentedSinglePageApp />
    )
  }} />
);

